import { FC } from 'react'
import { SiteModel } from '../../../core/_models'
import { formatEUR } from '_metronic/partials/widgets/tables/TenderListWidget'
type Props = {
  site: SiteModel
}
const WorksRehabilitionCell: FC<Props> = ({ site }) => {

  return (
    <div className='d-flex align-items-center'>
      {site.worksForRehabilitationEur != null && site.worksForRehabilitationEur != undefined && formatEUR(site.worksForRehabilitationEur.toFixed(2))}
    </div>
  )
}
export { WorksRehabilitionCell }
